import { render, staticRenderFns } from "./shift-controls.vue?vue&type=template&id=1b63934e&scoped=true"
import script from "./shift-controls.vue?vue&type=script&lang=js"
export * from "./shift-controls.vue?vue&type=script&lang=js"
import style0 from "./shift-controls.vue?vue&type=style&index=0&id=1b63934e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63934e",
  null
  
)

export default component.exports